import { useMemo } from "react";
import { type GridRowData } from "../../accounting/utils/transformForecastData";

/**
 * Hook to calculate row counts for approvals grid
 * Separates group headers from milestone rows for proper display
 */
export const useApprovalsRowCount = (gridRowData: GridRowData[]) => {
  return useMemo(() => {
    if (!Array.isArray(gridRowData)) {
      return {
        totalRows: 0,
        milestoneRows: 0,
        groupRows: 0,
      };
    }

    const milestoneRows = gridRowData.filter(
      (row) => row.rowType === "milestone",
    ).length;

    const groupRows = gridRowData.filter((row) =>
      ["dateGroup", "brandGroup", "campaignGroup"].includes(row.rowType),
    ).length;

    return {
      totalRows: gridRowData.length,
      milestoneRows,
      groupRows,
    };
  }, [gridRowData]);
};
